import {
  RazorImageFallback,
  RazorReturnInitial,
  RazorTextTrim,
} from "../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ALL_ICONS } from "../../assets/icons/AllIcons";
import RootState from "../../redux/type";
import { ALL_ROUTES } from "../../routes/AllRoutes";
import "../../styles/layout/HeaderNav.css";
import { capitalizeFirstLetter } from "../../utils/Helper";
import Skeleton from "react-loading-skeleton";
import {
  getAllNotification,
  getUnreadNotification,
} from "../../redux/notification";
import { useEffect } from "react";
import useNotificationSystem from "../../utils/useNotificationSystem";

interface myComponentProps {
  title?: string;
  onBack?: () => void;
  back?: boolean;
  handleNotify?: () => void;
}

const HeaderNav = ({ back, onBack, title, handleNotify }: myComponentProps) => {
  const dispatch = useDispatch();
  const { user, loading_user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const { unread_notification } = useSelector(
    (state: RootState) => state.notification
  );

  function arrayToString(arr: string[], separator: string = ", "): string {
    return arr.join(separator);
  }

  // This fetches all currency list
  useSelector((state: RootState) => state.settings);

  // For notification
  useEffect(() => {
    dispatch(getAllNotification({}) as any);
    dispatch(getUnreadNotification({}) as any);
  }, [dispatch]);

  // useNotificationSystem();

  const removeSeparator = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return capitalizeFirstLetter(chi?.replaceAll("_", " "));
      });

      return newList;
    }
  };

  return (
    <>
      <div
        onClick={() => {
        }}
        className="header-nav-smart-send-wrapper-box"
      >
        {/* back title box start */}
        <div className="back-title-box">
          {/* back box start */}
          {back && (
            <div
              onClick={() => {
                if (!onBack) {
                  navigate.length > 1
                    ? navigate(-1)
                    : navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
                } else {
                  onBack && onBack();
                }
              }}
              className="back-box"
            >
              <figure className="img-box">{ALL_ICONS?.back_icon}</figure>
            </div>
          )}
          {/* back box end */}
          {/* title box start */}
          {title && (
            <div className="title-box">
              <p className="title">{title}</p>
            </div>
          )}
          {/* title box end */}
        </div>
        {/* back title box end */}
        {/* icon noti box start */}
        <div
          onClick={handleNotify}
          className="icon-noti-box  icon-noti-box-two"
        >
          {unread_notification > 0 && (
            <div className="noti-box">
              <span>
                {unread_notification > 99 ? "99+" : unread_notification}
              </span>
            </div>
          )}
          <div className="icon-box">
            <figure className="img-box">{ALL_ICONS?.bell_icon}</figure>
          </div>
        </div>
        {/* icon noti box end */}
        {/* icon noti box start */}
        {/* <div className="icon-noti-box">
        <div className="noti-box">
          <span>3</span>
        </div>
        <div className="icon-box">
          <figure className="img-box">{ALL_ICONS?.notify_icon}</figure>
        </div>
      </div> */}
        {/* icon noti box end */}
        {/* avatar name role box start */}
        <div
          onClick={() => {
            navigate(ALL_ROUTES?.DASHBOARD_SETTINGS_PROFILE);
          }}
          className="avatar-name-role-box"
        >
          {loading_user ? (
            <>
              <Skeleton circle className="" width={35} height={35} />
            </>
          ) : (
            <RazorImageFallback
              className="avatar-box"
              url={user?.profile_image}
            >
              <div className="avatar-box">
                <span>
                  {RazorReturnInitial(
                    `${user?.first_name || ""} ${user?.last_name || ""}`
                  )}
                </span>
              </div>
            </RazorImageFallback>
          )}
          <div className="name-role-box">
            {loading_user ? (
              <>
                <Skeleton className="" width={120} height={15} />
                <Skeleton className="" width={80} height={7} />
              </>
            ) : (
              <>
                {" "}
                <p className="name">
                  {String(user?.first_name)?.length +
                    String(user?.last_name)?.length >
                  20
                    ? `${user?.first_name || ""} ${
                        RazorTextTrim(user?.last_name, 3) || ""
                      }`
                    : `${user?.first_name || ""} ${user?.last_name || ""}`}
                </p>
                <p className="role">
                  {user?.roles?.length > 0
                    ? RazorTextTrim(
                        arrayToString(removeSeparator(user?.roles)),
                        20
                      )
                    : user?.email || ""}
                </p>
              </>
            )}
          </div>
        </div>
        {/* avatar name role box end */}
      </div>
    </>
  );
};

export default HeaderNav;
